import Template from "./template.jsx";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";
import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { useProCliStore } from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/ProviderListv2/hooks/useProCliStore.js";
export default class FinanceCasesDetailProvidersRoute extends BaseRoute {
  @service("repositories/case-repository") caseRepository;
  @service("repositories/provider-client-status-repository") providerClientStatusRepository;
  element = (<Template />);

  async loader({ params }) {
    const { id } = params;
    const limit = useProCliStore.getState().limit;
    const orderingVal = useProCliStore.getState().orderingVal;
    const providerClientObj = await this.providerClientStatusRepository.query({
      case: id,
      limit: limit,
      ordering: orderingVal,
    });
    const providerClientRecCount =
      await this.providerClientStatusRepository.getTotalCount();
    return { providerClientObj, providerClientRecCount };
  }
}
